import React, { useEffect, useState } from 'react';
import { useAuthState } from "react-firebase-hooks/auth";
//import { database } from "./firebase";
import { auth,database ,logout} from "./firebase";
import { getDatabase, ref, child, get,remove } from "firebase/database";
import { useNavigate } from "react-router-dom";
import { reload } from 'firebase/auth';
import DateTime from './DateTime';

import "./i18n";
import { useTranslation } from "react-i18next";
import { FirebaseDBFileList } from './FirebaseDBFileList';


const db = getDatabase();


const FirebaseDB = () => {
  const [datas, setDatas] = useState([]);
  //const [user, setUser] = useState('');
  const [age, setAge] = useState('');
  const [num,setNum] = useState(0)
  //const userRef = database.ref('users');
  const userRef = ref(db);

  const [user, loading, error] = useAuthState(auth);
  const navigate = useNavigate();

  useEffect(() => {
    // userRef.on('value', snapshot => {
    //   const users = snapshot.val();
    //   const usersData = [];
    //   for(let id in users) {
    //     usersData.push({ ...users[id], id });
    //   }
  
    //   setDatas(usersData);
    // })

    if (loading) return;
    if (!user) return navigate("/");

    var count = 0 

    console.log(`users/${user?.uid}/items`);

    get(child(userRef, `users/${user?.uid}/items`)).then((snapshot) => {
      if (snapshot.exists()) {
        console.log(snapshot.val());
        const usersData = [];

        //setNum ( snapshot.count() )

        snapshot.forEach(function(d) {
          console.log(d.key);
          console.log(d.val());
          
          //setNum ( num +1 )
          count++
          
          const data = {key:d.key, user:d.val().deviceName ,
            state : 'offline',
            roomID:d.val().roomID,
            startDateTime:d.val().startDateTime,
            updateDateTime:d.val().updateDateTime,
            timeZone:d.val().timeZone,
            battery: d.val().battery,
            fileShow : false,
            deviceID: d.val().deviceID,
          };

          var now = new Date()
          var update = new Date(d.val().updateDateTime)
          update.setSeconds(update.getSeconds() + 65)
          console.log(update);

          if( now < update ){
            data.state = "online"
          }

          // if( d.val().roomID != "0"){
          //   data.state = "online"
          // }

          usersData.push(data);

        })

        for(let d in snapshot.val()) {
        }
        
        setDatas(usersData);

      } else {
        console.log("No data available");
      }
    }).catch((error) => {
      
      console.log(user?.uid);
      console.error(error);
    });

    
  }, [user, loading]);

  const onChange = (e) => {
    //e.target.name === 'user' ? setUser(e.target.value) : setAge(e.target.value);
  }

  const onClickAdd = () => {
    const userData = { user, age };

    userRef.push(userData);
    //setUser('');
    setAge('');
  }

  const onClickRemove = (id) => {
    
    remove(child(userRef, `users/${user?.uid}/items/${id}`))

    setDatas( datas.filter(el => el.key != id));
    //child(userRef, `users/${user?.uid}/items/${id}`).remove();
    //remove(ref(db, `users/${user?.uid}/items/${id}`))
    //userRef.child(id).remove();


  }

  const onFileView = (data) => {
    

    data.fileShow = !data.fileShow

    setDatas(datas.map(el => el.key === data.key ? {...el, fileShow: data.fileShow} : el));

    // remove(child(userRef, `users/${user?.uid}/items/${id}`))
    // setDatas( datas.filter(el => el.key != id));
    //child(userRef, `users/${user?.uid}/items/${id}`).remove();
    //remove(ref(db, `users/${user?.uid}/items/${id}`))
    //userRef.child(id).remove();


  }

  function refreshPage() {
    window.location.reload(false);
  }
  

  const onUpdate = (id) => {
    const [user] = datas.filter(el => el.id === id);

    userRef.child(id).update({
      age: user.age++
    });

    setDatas(datas.map(el => el.id === id ? {...el, age: el.age++} : el));
  };

  const { t, i18n } = useTranslation();

  return (
    <div >
      <div>
        CCTV device : {datas.length} unit
      </div>

      {datas?.map(data => <div key={data.id}>
        <div style={{
          backgroundColor: data.state == "online"? 'green' : 'white'
      }}>
          {t("device_id")} : {data.user}
          <br />
          {t("start_time")}: {data.startDateTime}
          <br />
          {t("update_time")} : {data.updateDateTime}
          <br />
          {t("time_zone")}: {data.timeZone}
          <br />
          {t("battery")} : {data.battery}
          <br />
          
          <br />
          roomID : {data.roomID}
          <br />
          {t("state")} : {data.state}

        </div>
        <br />
        <button style={{marginLeft: '10px', height: '60px', width : '200px'}}  onClick={() => window.open("https://androidtv.netlify.app/?admin=aa&id="+data.roomID, "_blank")}>{t("cctv_view")}</button> 
        
        <button style={{marginLeft: '10px',height: '60px', width : '200px'}} onClick={() => onFileView(data)}>{t("file_list")}</button>

        <button style={{marginLeft: '10px',height: '60px', width : '200px'}} onClick={() => onClickRemove(data.key)}>{t("cctv_delete")}</button>
        <hr />

        {
          data.fileShow && <FirebaseDBFileList uid={data.uid} deviceID={data.deviceID} ></FirebaseDBFileList>
        }


      </div>
      )}

      {/* <input onChange={onChange} name='user' placeholder='user' value={user}></input>
      <input onChange={onChange} name='age' placeholder='age' value={age}></input>
      <button onClick={onClickAdd}>추가하기</button> */}

        {/* <button className="dashboard__btn" onClick={refreshPage}>
          Page Refresh(화면갱신)
        </button> */}


<br />
<br />
      <DateTime></DateTime>
      
      <button className="dashboard__btn" onClick={logout}>
          Logout
        </button>

    </div>
  );
};

//export default FirebaseDB;
export {FirebaseDB};